import { SelectInputV2, SelectInputV2Props } from '@frontend/basic-forms';
import { SpotNetworkType } from '@frontend/spot/types';
import React from 'react';

const ID = 'spot-network-type-select';
export interface SpotNetworkTypeSelectProps extends Omit<SelectInputV2Props<SpotNetworkType>, 'options'> {}

export const SpotNetworkTypeSelect = (props: SpotNetworkTypeSelectProps) => {
    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            options={Object.values(SpotNetworkType).map((c) => ({
                label: c.replace(/_/g, ' '),
                value: c
            }))}
            label={props.label || 'Network type'}
        />
    );
};
